import { markdownToWordDocument } from "../../../utils/docExport";
import { requestPdf } from "../api/publicChat";
import { transformMermaidBlocksToInlineSvg } from "./inlineMermaidSvgs";
import { transformMermaidBlocksToImages } from "./mermaidForExport";

const triggerDownload = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const ensurePdfExtension = (filename: string): string =>
  filename.toLowerCase().endsWith(".pdf") ? filename : `${filename}.pdf`;

export const downloadDocxClientSide = async (
  markdown: string,
  filename: string,
  rootEl: HTMLElement | null
): Promise<void> => {
  const prepared = await transformMermaidBlocksToImages(markdown, rootEl);
  await markdownToWordDocument(prepared, filename);
};

/**
 * Render the assistant message to a PDF via the server-side Puppeteer
 * pipeline. Mermaid diagrams are inlined as base64 SVG data URIs so the
 * server never needs S3 access; the PDF endpoint at /public-api/jan/generate-pdf
 * streams the rendered bytes back, which we trigger as a browser download.
 *
 * Replaces the prior `window.print()` flow, which clipped wide diagrams
 * because the print stylesheet had no rule to scale oversized images
 * down to the printable page width.
 */
export const downloadPdfClientSide = async (
  markdown: string,
  filename: string,
  rootEl: HTMLElement | null
): Promise<void> => {
  const prepared = transformMermaidBlocksToInlineSvg(markdown, rootEl);
  const pdfFilename = ensurePdfExtension(filename);
  const blob = await requestPdf(prepared, pdfFilename);
  triggerDownload(blob, pdfFilename);
};
